import clsx from 'clsx';

interface ScrollToBottomProps {
  visible: boolean;
  onClick: () => void;
  // Optional unread count badge.
  unreadCount?: number;
}

/**
 * Floating button that snaps the conversation back to the latest message.
 * Renders null when `visible` is false so it never reserves space.
 */
export default function ScrollToBottom({ visible, onClick, unreadCount = 0 }: ScrollToBottomProps) {
  if (!visible) return null;

  return (
    <div className="absolute bottom-4 right-4 z-10">
      <button
        type="button"
        onClick={onClick}
        aria-label="Scroll to latest messages"
        className={clsx(
          'relative flex h-11 w-11 min-h-[44px] min-w-[44px] items-center justify-center',
          'rounded-full bg-white shadow-soft',
          'dark:bg-ink-700',
          'text-ink-700 hover:bg-ink-50 dark:text-ink-100 dark:hover:bg-ink-600',
          'transition focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500',
        )}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M12 5v14" />
          <path d="m19 12-7 7-7-7" />
        </svg>
        {unreadCount > 0 && (
          <span
            aria-label={`${unreadCount} unread`}
            className="badge absolute -right-1 -top-1"
          >
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>
    </div>
  );
}